module.exports = __webpack_public_path__ + "static/media/blockchain-development-icon.07c04160.svg";